angular
  .module("mercury.modules.stock.invoices")
  .config(["$stateProvider", function ($stateProvider) {
    // React Routes
    $stateProvider.state("Stock.Invoices", {
      url: "/invoices",
      contoller: "ReactCtrl",
    });
    $stateProvider.state("Stock.InvoiceHistory", {
      url: "/invoices/history",
      contoller: "ReactCtrl",
      data: {
        menuLinkState: "Stock.InvoiceHistory",
      },
    });
    $stateProvider.state("Stock.EditInvoice", {
      url: "/invoices/:invoiceId",
      contoller: "ReactCtrl",
      data: {
        menuLinkState: "Stock.Invoices",
      },
    });
  }]);
